import React from 'react'
import Nav from './navigation'
import Footer from './navigation/Footer'
import "./layout.css"

const Layout = ({ children }) => (
  <div>
    <Nav />
    <div className="contain">
      {children}
    </div>
    <div style={{ height: '3em' }} />
    <Footer />
  </div>
)

export default Layout